module.exports = __webpack_public_path__ + "img/calendar.0032bb72.svg";